import { apiGet, apiPost } from '@/features/shared/utils/dataFetching'
import {
  type BulkProductNoteQueryKey,
  type ProductNoteQueryKey,
} from '@/features/shop/services/ProductNote/queries'
import { type QueryFunctionContext } from '@tanstack/react-query'
import {
  type ProductNotesResponse,
  type ProductNoteResponse,
} from '@/features/shop/services/ProductNote/types'

export const fetchProductNote = async (context: QueryFunctionContext<ProductNoteQueryKey>) => {
  const [, { userId, productId, categoryId }] = context.queryKey

  return apiGet<ProductNoteResponse>({
    config: {
      url: `member-product-data/v1/customers/${userId}/products/${productId}/notes`,
      params: {
        category_id: categoryId,
      },
    },
    context,
    fetcherName: 'fetchProductNote',
  })
}

export const fetchProductNotes = async (
  context: QueryFunctionContext<BulkProductNoteQueryKey>,
): Promise<Record<number, string>> => {
  const [, { userId, products }] = context.queryKey

  const { notes } = await apiPost<ProductNotesResponse>({
    config: {
      url: `member-product-data/v2/customers/${userId}/notes`,
      data: { products },
    },
    context,
    fetcherName: 'fetchProductNotes',
  })

  return Object.fromEntries(notes.map(({ product_id, product_note }) => [product_id, product_note]))
}
